/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import Signals from '../../signals/Signals';

import FormGroup from '../../components/ui/FormGroup/FormGroup';
import FormField from '../../components/ui/FormField/FormField';

import userUpdate from '../../requests/userUpdate';
import { extractErrorMessage } from '../../utils/extractErrorMessage';

/**
 *
 */
class OnBoardingUserAddress extends React.Component {
	/**
	 *
	 */
	constructor(props) {
		super(props);

		this.state = { errors: null, sumbitting: false };

		this.onSkip = this.onSkip.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onSubmitSuccess = this.onSubmitSuccess.bind(this);
		this.onSubmitError = this.onSubmitError.bind(this);

		this.onInputChange = this.onInputChange.bind(this);
	}

	/**
	 *
	 */
	render() {
		const formClasses = classNames({ 'form--submitting': this.state.submitting });

		return (
			<div className={`panel border border--dark ${this.props.className}`}>
				<form
					className={`on-boarding__form ${formClasses}`}
					name="on-boarding"
					onSubmit={this.onSubmit}>
					<div className="on-boarding__header padding border--bottom border--dark">
						<h2>
							<FormattedMessage id="onboarding.user.address.title" />
						</h2>
					</div>

					<div className="padding-small">
						<FormGroup errors={this.state.errors}>
							{/* Address */}
							<FormField
								className="col--12"
								error={extractErrorMessage(this.state.errors, 'address.address')}>
								<label>
									<FormattedMessage id="onboarding.field.user.address" />
								</label>
								<input
									type="text"
									name="address"
									required
									value={
										this.state.address !== undefined
											? this.state.address
											: this.props.user.address.address
									}
									onChange={this.onInputChange}
								/>
							</FormField>

							{/* Postalcode */}
							<FormField
								className="col--4"
								error={extractErrorMessage(this.state.errors, 'address.postalCode')}>
								<label>
									<FormattedMessage id="onboarding.field.user.postalcode" />
								</label>
								<input
									name="postalCode"
									type="text"
									value={
										this.state.postalCode !== undefined
											? this.state.postalCode
											: this.props.user.address.postalCode
									}
									maxLength="7"
									placeholder={this.props.intl.formatMessage({ id: 'placeholder.postalcode' })}
									required
									onChange={this.onInputChange}
								/>
							</FormField>

							{/* City */}
							<FormField
								className="col--8"
								error={extractErrorMessage(this.state.errors, 'address.city')}>
								<label>
									<FormattedMessage id="onboarding.field.user.city" />
								</label>
								<input
									name="city"
									type="text"
									value={
										this.state.city !== undefined ? this.state.city : this.props.user.address.city
									}
									required
									onChange={this.onInputChange}
								/>
							</FormField>
						</FormGroup>
					</div>

					<div className="options-footer border--top border--dark grid grid--spread">
						<button
							type="button"
							className="on-boarding__skip-button button--tertiary"
							onClick={this.onSkip}>
							{this.props.intl.formatMessage({ id: 'onboarding.form.skip' })}
						</button>
						<input
							className="on-boarding__submit-button"
							type="submit"
							value={this.props.intl.formatMessage({ id: 'onboarding.form.submit' })}
						/>
					</div>
				</form>
			</div>
		);
	}

	/**
	 *
	 * @param e
	 */
	onInputChange(e) {
		this.state[e.target.name] = e.target.value;
		this.forceUpdate();
	}

	/**
	 *
	 */
	onSkip() {
		this.props.successCallback();
	}

	/**
	 *
	 */
	onSubmit(e) {
		e.preventDefault();

		if (this.state.sumbitting) {
			return;
		}

		const data = {};
		for (const key in this.state) {
			if (this.state.hasOwnProperty(key)) {
				switch (key) {
					case 'city':
						data['address.city'] = this.state[key];
						break;
					case 'address':
						data['address.address'] = this.state[key];
						break;
					case 'postalCode':
						data['address.postalCode'] = this.state[key];
						break;
					case 'submitting':
					case 'errors':
						// do nothing
						break;
					default:
						data[key] = this.state[key];
				}
			}
		}

		this.setState({ errors: null, submitting: true });
		userUpdate(data).then(this.onSubmitSuccess).catch(this.onSubmitError);
	}

	/**
	 *
	 * @param response
	 */
	onSubmitSuccess(response) {
		this.setState({ submitting: false });
		this.props.user.update(response.data);
		this.props.successCallback(this);
	}

	/**
	 *
	 * @param error
	 */
	onSubmitError(error) {
		this.setState({ submitting: false });
		if (error.response && error.response.body) {
			this.setState({ errors: error.response.body });
		} else {
			Signals.Error.dispatch(error);
		}
	}
}

OnBoardingUserAddress.propTypes = {
	intl: PropTypes.object,
	successCallback: PropTypes.func.isRequired,
	user: PropTypes.object.isRequired,
	className: PropTypes.string
};

export default injectIntl(OnBoardingUserAddress);
